import { __read } from "tslib";
import * as u from './urx';
import { listStateSystem, buildListStateFromItemCount } from './listStateSystem';
import { sizeSystem } from './sizeSystem';
import { propsReadySystem } from './propsReadySystem';
import { initialTopMostItemIndexSystem } from './initialTopMostItemIndexSystem';
export var initialItemCountSystem = u.system(function (_a) {
    var _b = __read(_a, 4), _c = _b[0], sizes = _c.sizes, firstItemIndex = _c.firstItemIndex, data = _c.data, gap = _c.gap, initialTopMostItemIndex = _b[1].initialTopMostItemIndex, _d = _b[2], initialItemCount = _d.initialItemCount, listState = _d.listState, didMount = _b[3].didMount;
    u.connect(u.pipe(didMount, u.withLatestFrom(initialItemCount), u.filter(function (_a) {
        var _b = __read(_a, 2), count = _b[1];
        return count !== 0;
    }), u.withLatestFrom(initialTopMostItemIndex, sizes, firstItemIndex, gap, data), u.map(function (_a) {
        var _b = __read(_a, 6), _c = __read(_b[0], 2), count = _c[1], initialTopMostItemIndexValue = _b[1], sizes = _b[2], firstItemIndex = _b[3], gap = _b[4], _d = _b[5], data = _d === void 0 ? [] : _d;
        return buildListStateFromItemCount(count, initialTopMostItemIndexValue, sizes, firstItemIndex, gap, data);
    })), listState);
    return {};
}, u.tup(sizeSystem, initialTopMostItemIndexSystem, listStateSystem, propsReadySystem), { singleton: true });
